import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { virtualOfficeChildrenRoutes } from "./virtualOfficeChildren";

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));

interface RouteItem {
    path: string;
    element: JSX.Element;
}

const virtualOfficeRoutes = {
    path: '/oficina-virtual',
    element: <Outlet />,
    errorElement: <NotFoundPage />,
    children: [
      ...virtualOfficeChildrenRoutes.map(({ path, element }: RouteItem) => ({
        path,
        element,
      })),
    ],
  }
;

export default virtualOfficeRoutes;